import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import VisIcon from '../../../images/submenu_open copy 6.png'
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'


class Adresse extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleAdresse = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateAdresse = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Adresse",
            adresse: this.props.adresse
        })
    }

    showAdresse = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowAdresse,
                adresse: this.props.adresse
            }
        })
    }

    render() {
        const { t } = this.props
        var adresse = this.props.adresse
        var title = `${adresse.adressekode||''} ${adresse.adressenavn||''} ${adresse.nummer||''}${adresse.bokstav||''}`.trim() || adresse.adressetilleggsnavn || adresse.domeneklasse
        var kommune = adresse.kommuneId ? `${adresse.kommunenavn} (${adresse.kommuneId})` : null
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleAdresse}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{title}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.navigateAdresse}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.adresse')}</div>
                    </div>
                    <div className="icon-image right tooltip" onClick={this.showAdresse}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.adresse')}</div>
                    </div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adressetilleggsnavn')}</div>
                            <div className="value">{adresse.adressetilleggsnavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kortnavn')}</div>
                            <div className="value">{adresse.kortnavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('nummer')}</div>
                            <div className="value">{adresse.nummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('undernummer')}</div>
                            <div className="value">{adresse.undernummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('bokstav')}</div>
                            <div className="value">{adresse.bokstav}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{kommune}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adressekode')}</div>
                            <div className="value">{adresse.adressekode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('adressenavn')}</div>
                            <div className="value">{adresse.adressenavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kortadressenavn')}</div>
                            <div className="value">{adresse.kortAdressenavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('adressetype')}</div>
                            <div className="value">{adresse.domeneklasse}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Adresse)